import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { COMPARE_PRICE, PRICE } from '../data/content';
const recap = ['6 tomes', '5 bonus', '240 pages', '96 cours'];
const reassurances = ['Téléchargement numérique immédiat', 'PDF à imprimer', 'Garantie satisfaction 7 jours'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="15c2h3gvmh1vl">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1jbaimgf9cm2y" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t2ycenzaef7l">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1t2ercyecbapc">
          Vos cours de yoga peuvent être <em className="text-red-700" data-id="element-118" data-mp="223mj0xmcpdag">prêts dès aujourd'hui.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="221jpi3lzp20z">
          Au lieu de chercher des séquences, d'écrire chaque cours vous-même et de passer vos dimanches
          soir à préparer, vous avez un pack de yoga organisé pour toute l'année. Plus de temps pour
          ce qui compte vraiment :
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="x3irjmtvqfdp">
          Vos élèves. Votre pratique. Votre vie en dehors du studio.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="164goxm9tbonb">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1b2i4vybxz7uk">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1b171hzmes23z">
          <s className="mr-3 align-middle text-3xl text-slate-900/40 sm:text-4xl" data-id="element-124" data-mp="1ktd21xqq7rus"><span className="sr-only" data-id="element-125" data-mp="1ksl5ajle7o2x">Au lieu de </span>{COMPARE_PRICE}</s>
          {PRICE}
        </p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-126" data-mp="1puagq0cj23rj">Paiement unique – sans abonnement.</p>

        <div className="mt-8 flex justify-center" data-id="element-127" data-mp="1tuaxvsr0gt2a">
          <CtaButton className="w-full sm:w-auto" data-id="element-128" data-mp="3qu5q68v05ppm" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-129" data-mp="3qsb1qkkivfgs">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-130" data-mp="3i4qmx101iuv">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-131" data-mp="3jfsgravwgjc" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}